import React, { useState, useEffect, useRef } from 'react';

import Property from './Property';
import { makeStyles } from '@material-ui/core/styles';
import './dnd.css'
import TaskAnnotations from './TaskAnnotations';

import ReactFlow, {
    ReactFlowProvider,
    addEdge,
    removeElements,
    getOutgoers,
    Controls, MiniMap, Background
  } from 'react-flow-renderer';  

  import BizNode from './BizNode';
  import IfNode from './IfNode';
  import LoopNode from './LoopNode';
  import MouseNode from './MouseNode';
  import FileNode from './FileNode';
  import WaitNode from './WaitNode';
  import BotNode from './BotNode';
  import CallNode from './CallNode';
  import RESTNode from './RESTNode';
  import KeyNode from './KeyNode';
  import RegularNode from './RegularNode';
  import SpeakerNode from './SpeakerNode';
  import SpeechToTextNode from './SpeechToTextNode';
  import ScreenActivityNode from './ScreenActivityNode';  
  import BrowserNode from './BrowserNode';
  import nodeStyles from './nodeStyles';
  import message from './message';
  import customConnectionLine from './customConnectionLine';
  import getFields from './ActionFields';
  
  import ButtonEdge from './ButtonEdge';
  
  import { save } from 'save-file';

  import Loading from './Loading';

  import secondsToMin from './Util';
  
  const edgeStyle = {
    // stroke: '#9999ff',
    strokeWidth:1.7,
    // strokeOpactiy:0.1

  };


  
// not used - check Process Discovery
const initialElements = [
    {
      id: '1',
      type: 'input',
      data: { label: 'Screen View' },
      position: { x: 250, y: 50 },
      style: {
        background: 'steelblue',
        color: 'white',
        border: '1px solid #222138',
        width: 100,
        fontSize: '16',

      },
    }
  ];


  let id = 3;
  const getId = () => `dnd_${id++}`;

  


export default function VisualizeFlow(props)
{
    var lastPosition = { x:250, y:50}


    const [entityName, setEntityName] = useState('New')
    const [selectedElement, setSelectedElement] = useState(null)

    const [fromElement, setFromElement] = useState('1')
    const [toElement, setToElement] = useState('2')

    const onElementClick = (event, element) => {
      event.preventDefault();
      console.log("Click")
      setSelectedElement(element)
  }

    
  
    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);

    const onLoad = (_reactFlowInstance) =>
      setReactFlowInstance(_reactFlowInstance);
  
    const updateProperties = (properties) => {
        selectedElement.data.attributes = properties

    }


    const nodeTypes = {
      BizNode: BizNode,
      IfNode:IfNode,
      LoopNode: LoopNode,
      MouseNode:MouseNode,
      FileNode:FileNode,
      KeyNode:KeyNode,
      BotNode:BotNode,
      CallNode:CallNode,
      RESTNode:RESTNode,
      WaitNode:WaitNode,
      BrowserNode:BrowserNode,
      SpeakerNode:SpeakerNode,
      SpeechToTextNode:SpeechToTextNode,
      RegularNode:RegularNode,
      ScreenActivityNode:ScreenActivityNode,
    };


 
        
    const renderMain = () => {

      var entity = document.getElementById('entity');
      if (entity != null)
      entity.setAttribute('value', entityName)
      return (
      <div className='designer'>
      <ReactFlow
      style={style}
      elements={props.data}
      connectionLineComponent={customConnectionLine}
      nodeTypes={nodeTypes}
      onLoad={onLoad}
      onElementClick={onElementClick}
      onlyRenderVisibleElements={true}
      nodesDraggable={false}
      panOnScroll={true}

>
      {/* <MiniMap/> */}
      <Controls 
      showInteractive={false}
      />
      <Background variant="dots" color="gray" gap={10} /> 

    </ReactFlow>
    </div>
    );




    }  
  
    const changeTitle = (event) => {
      console.log("clicked on entity")
      var entity = document.getElementById('entity')
      var entity2 = document.getElementById('entity2')

      entity.setAttribute('style', 'visibility:hidden')
      entity2.setAttribute('type', 'text') 
      
      console.log("enabled input")

    }  

    const onChange=(event)=>{
      
      setEntityName(event.target.value);
      console.log(entityName)
    }

    const onFocusOut=(event) => {
      console.log("focus lost")
      var entity = document.getElementById('entity')
      var entity2 = document.getElementById('entity2')
      entity.setAttribute('style', '')
      entity2.setAttribute('type', 'hidden') 
      console.log(entityName)
      entity.setAttribute('innerHtml',  entityName)

    }

    const style = {
        // background:'#52c9d0',
        // background: '#9eccdb',
        // background:'#bed6dd',

        width: '100%',
        height: 700
      };

      
      
      return (

      <div className="process-cont">
            <Loading loading={props.loading}/>
      
      <div className="visualflow">
        <div style={{align:'center'}} className='taskname'> <h3  >Task Name -  {props.currentTaskName}</h3></div>

        <div className="taskcard">  
              <h4>Total Time Taken: {secondsToMin(props.totalTime)}</h4>
              <h4>Total Screens: {props.numScreens}</h4>
        </div>

        <div >

          <ReactFlowProvider>

          <div className="reactflow-wrapper" ref={reactFlowWrapper}>
          {renderMain()}

          </div>

          </ReactFlowProvider>
        </div>

      </div>
      </div>
      );
}
